import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { act_GetFrequencyChartsData } from '../../../actions/EEReportAction';
import ChartLoader from '../../Loaders/ChartLoader';
import Auth from '../../../shared/Auth';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);

Highcharts.setOptions({
  global: {
    useUTC: false,
  },
});
class EEFrequencyChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: null,
      reinitialize: true,
    };
    this.toTimestamp = this.toTimestamp.bind(this);
    this.getData = this.getData.bind(this);
    this.drawChart = this.drawChart.bind(this);
  }

  toTimestamp(strDate) {
    const datum = Date.parse(strDate);
    return datum;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    try {
      if (
        this.props.deviceId !== nextProps.deviceId ||
        this.props.stateChanged !== nextProps.stateChanged
      ) {
        this.getData(nextProps.deviceId, nextProps.deviceId, 1);
        return;
      }

      if (this.props.widgetSetting.w1Size !== nextProps.widgetSetting.w1Size) {
        this.getData(nextProps.deviceId, nextProps.deviceId, 1);
        return;
      }
      if (
        this.props.selectedObj.StartTime !== nextProps.selectedObj.StartTime
      ) {
        const day1 = nextProps.selectedObj.StartTime.substr(8, 2);
        const month1 = nextProps.selectedObj.StartTime.substr(5, 2);
        const year1 = nextProps.selectedObj.StartTime.substr(0, 4);
        const time1 = nextProps.selectedObj.StartTime.substr(11, 8);

        if (this.state.options !== null) {
          const _options = this.state.options;
          _options.xAxis.plotLines[0].value = this.toTimestamp(
            `${month1}/${day1}/${year1} ${time1}`
          );
          _options.yAxis.plotLines[0].value = nextProps.selectedObj.limitToShow;
          const selected = this.toTimestamp(
            `${month1}/${day1}/${year1} ${time1}`
          );
          // added 5 hours for showing that line in bit inside of box
          const dt = new Date(`${month1}/${day1}/${year1} ${time1}`);
          const newdt = dt.setHours(dt.getHours() + 5);
          _options.xAxis.min = selected;
          _options.xAxis.max = newdt;
          this.setState({
            options: _options,
          });
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  UNSAFE_componentWillMount() {
    this.getData(this.props.deviceId, this.props.status, 1); // 1 no of months to load
  }

  async getData(deviceId, status, size) {
    this.setState({ reinitialize: true });
    const obj = {
      deviceId,
      sze: size,
      status: status?.toString().toLowerCase(),
    };
    const current = this;
    const checkToken = await Auth();
    if (checkToken) {
      this.props
        .act_GetFrequencyChartsData(obj)
        .then((res) => {
          if (res.payload.data.statusCode === 200) {
            current.drawChart(res.payload.data.result, size);
          }
        })
        .catch((error) => {
          console.log(error);
          current.drawChart([], size);
        });
    }
  }

  drawChart(data, NumberOfMonths) {
    const _self = this;
    const frequency_R = [];
    const frequency_Y = [];
    const frequency_B = [];
    let highestRTimeStamp = 0;

    data.forEach(async (element) => {
      const tmstmp = Date.parse(element.timeStamp);
      frequency_R.push([tmstmp, parseFloat(element.frequency1)]);
      frequency_Y.push([tmstmp, parseFloat(element.frequency2)]);
      frequency_B.push([tmstmp, parseFloat(element.frequency3)]);

      if (element.status === 'A') {
        if (tmstmp > highestRTimeStamp) {
          highestRTimeStamp = tmstmp;
        }
      }
    });

    let selectedPoint;
    let limitPoint = null;
    let min;
    let max;
    if (this.props.selectedObj) {
      const day1 = this.props.selectedObj.StartTime.substr(8, 2);
      const month1 = this.props.selectedObj.StartTime.substr(5, 2);
      const year1 = this.props.selectedObj.StartTime.substr(0, 4);
      const time1 = this.props.selectedObj.StartTime.substr(11, 8);

      const dt = new Date(`${month1}/${day1}/${year1} ${time1}`);
      const newdt = dt.setHours(dt.getHours() + 10);
      min = dt;
      max = newdt;
      selectedPoint = Date.parse(
        this.props.selectedObj.StartTime.replace('T', ' ')
      );
      limitPoint = this.props.selectedObj.limitToShow;
    }

    this.setState({
      options: {
        chart: {
          renderTo: 'PowerVsTimeForecastChartContainer',
          type: 'line',
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  enabled: false,
                },
              },
            },
          ],
        },
        rangeSelector: {
          buttons: [
            {
              type: 'day',
              count: 1,
              text: '1d',
            },
            {
              type: 'week',
              count: 1,
              text: '1w',
            },
            {
              type: 'month',
              count: 1,
              text: '1m',
            },
            {
              type: 'all',
              text: '6m',
              events: {
                click() {
                  _self.getData(_self.props.deviceId, _self.props.status, 6); // 6 no of months
                },
              },
            },
          ],
          inputEnabled: true,
          selected: NumberOfMonths === 1 ? 0 : 3,
          inputBoxWidth: 75,
          inputBoxHeight: 18,
          buttonTheme: {
            height: 18,
            padding: 2,
            undefined: 0,
            width: 15,
            Index: 7,
          },
        },
        title: {
          text: 'Frequency Profile',
        },
        xAxis: {
          type: 'datetime',
          // min: selectedPoint, //previous day
          // max: selectedPoint,
          min: data.length > 0 && min,
          max: data.length > 0 && max,
          plotLines: [
            {
              color: 'grey', // Color value
              value: data.length > 0 && selectedPoint, // Value of where the line will appear
              width: 1, // Width of the line
            },
          ],
        },
        yAxis: {
          title: {
            text: 'Frequency (HZ)',
          },
          plotLines: [
            {
              value: limitPoint,
              color: 'grey',
              width: 2,
            },
          ],
        },
        legend: {
          enabled: true,
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom',
        },
        exporting: {
          enabled: true,
          buttons: {
            contextButton: {
              menuItems: [
                'downloadPNG',
                'downloadJPEG',
                'downloadPDF',
                'downloadSVG',
                'separator',
                'downloadCSV',
                'downloadXLS',
                'viewData',
              ],
            },
          },
        },
        navigator: {
          enabled: false,
          reversed: false,
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
          valueDecimals: 2,
          split: true,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: 'Frequency-R',
            color: '#da532c',
            marker: { enabled: false, symbol: 'circle', radius: 2 },
            lineWidth: 2,
            data: frequency_R,
            zoneAxis: 'x',
            zones: [
              {
                value: highestRTimeStamp,
              },
              {
                dashStyle: 'ShortDot',
              },
            ],
          },
          {
            name: 'Frequency-Y',
            color: '#FFFF00',
            marker: { enabled: false, symbol: 'circle', radius: 2 },
            lineWidth: 2,
            data: frequency_Y,
            zoneAxis: 'x',
            zones: [
              {
                value: highestRTimeStamp,
              },
              {
                dashStyle: 'ShortDot',
              },
            ],
          },
          {
            name: 'Frequency-B',
            color: '#2d89ef',
            marker: { enabled: false, symbol: 'circle', radius: 2 },
            lineWidth: 2,
            data: frequency_B,
            zoneAxis: 'x',
            zones: [
              {
                value: highestRTimeStamp,
              },
              {
                dashStyle: 'ShortDot',
              },
            ],
          },
        ],
      },
      reinitialize: false,
    });
  }

  render() {
    return (
      <div>
        {!this.state.reinitialize ? (
          <HighchartsReact
            highcharts={Highcharts}
            constructorType={'stockChart'}
            options={this.state.options}
          />
        ) : (
          <ChartLoader height="150" width="600" />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  widgetSetting: state.WidgetSettingReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      act_GetFrequencyChartsData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EEFrequencyChart);
